import { render, staticRenderFns } from "./OkConfirmModal.vue?vue&type=template&id=db46e2c0&"
import script from "./OkConfirmModal.vue?vue&type=script&lang=js&"
export * from "./OkConfirmModal.vue?vue&type=script&lang=js&"
import style0 from "./OkConfirmModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports